import Desktop from "../library/desktop";
import Table from "../library/table";
import { UpdateFuncType } from "./ElementListAdd";

import Form from "./Form";

const ElementListAddTable: React.FC<{
	element: Table | Desktop;
	onUpdate: UpdateFuncType;
}> = ({ element, onUpdate }) =>
	element && (
		<Form>
			<Form.Labels>
				<Form.Field>Width</Form.Field>
				<Form.Field>Height</Form.Field>
				<Form.Field>Depth</Form.Field>
				<Form.Field>Top height</Form.Field>
				<Form.Field>Foot</Form.Field>
			</Form.Labels>
			<Form.Values>
				<Form.InputNumber name="width" value={element.width} onChange={onUpdate} />
				<Form.InputNumber name="height" value={element.height} onChange={onUpdate} />
				<Form.InputNumber name="depth" value={element.depth} onChange={onUpdate} />
				<Form.InputNumber name="topHeight" value={element.topHeight} onChange={onUpdate} />
				<Form.InputNumber name="footWidth" value={element.footWidth} onChange={onUpdate} />
			</Form.Values>
		</Form>
	);

export default ElementListAddTable;
